import * as React from "react";
import { SVGProps, memo } from "react";

const Required = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.252 13.0614L8.25904 16.6264L10.0924 17.8801L12.4227 13.9772L14.7641 18L16.5863 16.6809L13.6817 13.1487L18 12.1457L17.3263 10.0089L13.262 11.7205L13.6486 7H11.4177L11.76 11.6551L7.66265 9.9108L7 12.0149L11.252 13.0614Z" fill="currentColor" /></svg>;

const Memo = memo(Required);
export default Memo;